import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import Select from "react-select";
import Breadcrumb from "../../layout/breadcrumb";
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { saveContractDetails } from "../../redux/revendeur/distributorActions";
import contractServices from "../../services/contract/contractServices";
import { toast } from "react-toastify";
const CustomerCareCard = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [selectOption, setOptionSelected] = useState(null);
  const [Verticalcenter, setVerticalcenter] = useState(false);
  const [option, setListOption] = useState([
    { label: "Cin", value: "Cin" },
    { label: "Passport", value: "Passport" },
    { label: "Carte séjour", value: "Carte séjour" },
  ]);
  const [contractDto , setContractDto]=useState({
        cin: "",
        facture: "",
        firstName: "",
        iddistributor: localStorage.getItem("idDist"),
        iduserG: localStorage.getItem("id"),
        idformule: "",
        lastName: "",
        phone: ""
  })
   const Verticalcentermodaltoggle = () => {
    
        setVerticalcenter(!Verticalcenter);
      
    
  };
  const contractDetails = useSelector(({ distributorReducers }) => {
    return distributorReducers.contarctDetails;
  });
  const [customer, setCustomer] = useState(
    contractDetails[0]?.typeCustomer === "M"
      ? {
          typeCustomer: contractDetails[0]?.typeCustomer,
          taxRegistrationNumber: contractDetails[0]?.taxRegistrationNumber,
        }
      : {
          typeCustomer: contractDetails[0]?.typeCustomer,
          cin: contractDetails[0]?.cin,
        }
  );
  const [disabled, setDisabled] = useState(false);
  const [detailsCustomer, setDetailsCustomer] = useState();
  useEffect(() => {
    const uid = localStorage.getItem("id");
    if (localStorage.getItem("role") !== "Distributeur" && !(localStorage.getItem("role") === "FrontOffice") ) {
      history.goBack();
    } else if (!contractDetails[1]) {
      history.push("/new-sale");
    }
    contractServices
      .getCustomerByCin(contractDetails[0]?.cin, uid)
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          setDisabled(true);
          localStorage.setItem("customer", JSON.stringify(res.data));
          setCustomer(res.data);
          setDetailsCustomer(res.data);
        }
      });
  }, [contractDetails[0]]);

  const onChangeSelect = (item) => {
    setOptionSelected(item);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomer((detailsCustomer) => ({
      ...detailsCustomer,
      [name]: value,
    }));
  };
  const detais = [contractDetails[1], customer];
  const handleSubmit = (e) => {
    e.preventDefault();
    let contractDto = {
        cin: customer.cin,
        facture: customer.facture,
        firstName: customer.firstName,
        iddistributor: localStorage.getItem("idDist"),
        iduserG: localStorage.getItem("id"),
        idformule: contractDetails[1].idformula,
        lastName: customer.lastName,
        phone: customer.phone
    }
    contractServices.createContractCare(contractDto).then((res) => {
        if (res.status === 200) {
              Verticalcentermodaltoggle()
        
        }
      });

    
  };
  return (
    <div>
      <Breadcrumb 
      parent={"Nouvelle Vente"} 
      title={"Fiche Client"} 
      />
      <Container fluid={true}>
        <Card className="shadow-lg p-0 shadow-showcase">
          <CardHeader className="m-0 pb-0">
            <Row>
              <Col className="text-right"></Col>
            </Row>
          </CardHeader>

          <CardBody className="pt-2">
            <Form className="needs-validation" onSubmit={handleSubmit}>
              <div className="form-row">
                <Col md="5 mb-6">
                  <Label
                    style={{ fontSize: "16px", fontWeight: "400" }}
                    htmlFor="validationCustom01"
                  >
                    Nom
                    {/* Last Name */}
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    style={{ height: "50px" }}
                    className="form-control"
                    name="lastName"
                    type="text"
                    placeholder="Nom"
                    disabled={detailsCustomer?.lastName ? disabled : false}
                    value={customer?.lastName}
                    onChange={handleChange}
                    required={true}
                  />
                  <span></span>
                </Col>
                <Col md="5 mb-4">
                  <Label
                    style={{ fontSize: "16px", fontWeight: "400" }}
                    htmlFor="validationCustom01"
                  >
                    Prénom
                    {/* First Name */}
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    style={{ height: "50px" }}
                    className="form-control"
                    name="firstName"
                    type="text"
                    placeholder="Prénom"
                    disabled={detailsCustomer?.firstName ? disabled : false}
                    value={customer?.firstName}
                    onChange={handleChange}
                    required={true}
                  />
                  <span></span>
                </Col>
                <Col md="5 mb-4">
                  <Label
                    style={{ fontSize: "16px", fontWeight: "400" }}
                    htmlFor="validationCustom01"
                  >
                    Phone
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    style={{ height: "50px" }}
                    className="form-control"
                    name="phone"
                    type="number"
                    placeholder="Phone"
                    disabled={detailsCustomer?.phone ? disabled : false}
                    value={customer?.phone}
                    onChange={handleChange}
                    required={true}
                  />
                  <span></span>
                </Col>
                <Col md="5 mb-6">
                  <Label
                    style={{ fontSize: "16px", fontWeight: "400" }}
                    htmlFor="validationCustom01"
                  >
                    Facture
                    {/* Last Name */}
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    style={{ height: "50px" }}
                    className="form-control"
                    name="facture"
                    type="text"
                    placeholder="facture"
                    disabled={detailsCustomer?.facture ? disabled : false}
                    value={customer?.facture}
                    onChange={handleChange}
                    required={true}
                  />
                  <span></span>
                </Col>
                {customer.typeCustomer == "M" ? (
                  <></>
                ) : (
                  <>
                    <Col md="5 mb-4">
                      <Label
                        style={{ fontSize: "16px", fontWeight: "400" }}
                        htmlFor="validationCustom02"
                      >
                        Nature de la pièce
                        {/* Type */}
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Select
                        className="select-heghit"
                        // value={selectOption}
                        onChange={onChangeSelect}
                        defaultValue={{ label: "Cin", value: "Cin" }}
                        options={option}
                      />
                      <span></span>
                    </Col>

                    <Col md="5 mb-4">
                      <Label
                        style={{ fontSize: "16px", fontWeight: "400" }}
                        htmlFor="validationCustom02"
                      >
                        {selectOption ? selectOption.label : "Cin"}
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        style={{ height: "50px" }}
                        className="form-control"
                        name="cin"
                        type="text"
                        placeholder={selectOption?.label}
                        disabled={detailsCustomer?.cin ? disabled : false}
                        value={contractDetails[0]?.cin}
                        onChange={handleChange}
                        required={true}
                      />
                      <span></span>
                    </Col>
                  </>
                )}

                {customer.typeCustomer == "M" ? (
                  <>
                    <Col md="5 mb-6">
                      <Label
                        style={{ fontSize: "16px", fontWeight: "400" }}
                        htmlFor="validationCustom02"
                      >
                        Raison Social
                        {/* Company name */}
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        style={{ height: "50px" }}
                        className="form-control"
                        name="socialReason"
                        type="text"
                        placeholder="Raison Social"
                        disabled={
                          detailsCustomer?.socialReason ? disabled : false
                        }
                        value={customer.socialReason}
                        onChange={handleChange}
                        required={true}
                      />
                      <span></span>
                    </Col>
                    <Col md="5 mb-6">
                      <Label
                        style={{ fontSize: "16px", fontWeight: "400" }}
                        htmlFor="validationCustom02"
                      >
                        Numéro Fiscale
                        {/* Tax Number */}
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        style={{ height: "50px" }}
                        className="form-control"
                        name="taxRegistrationNumber"
                        type="text"
                        placeholder="Numéro Fiscale"
                        disabled={
                          detailsCustomer?.taxRegistrationNumber
                            ? disabled
                            : false
                        }
                        value={contractDetails[0]?.taxRegistrationNumber}
                        onChange={handleChange}
                        required={true}
                      />
                      <span></span>
                    </Col>
                    <Col md="5 mb-6">
                      <Label
                        style={{ fontSize: "16px", fontWeight: "400" }}
                        htmlFor="validationCustom02"
                      >
                        Cin
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        style={{ height: "50px" }}
                        className="form-control"
                        name="cin"
                        type="number"
                        placeholder="cin"
                        disabled={
                          detailsCustomer?.cin
                            ? disabled
                            : false
                        }
                        value={contractDetails[0]?.cin ? contractDetails[0]?.cin : customer.cin}
                        onChange={handleChange}
                        required={true}
                      />
                      <span></span>
                    </Col>
                  </>
                ) : (
                  <></>
                )}
              </div>

              <Row>
                <Col md="5 mb-6">
                  <Button
                    color="danger"
                    className="float-left"
                    style={{ width: "55%", height: "45px" }}
                    onClick={() => {
                      history.push("/new-sale");
                    }}
                  >
                    Retour
                    {/* Back */}
                  </Button>
                </Col>
                <Col md="5 mb-6">
                  <Button
                    color="primary"
                    className="float-right"
                    type="submit"
                    style={{ width: "55%", height: "45px" }}
                  >
                    Valider
                    {/* To validate */}
                  </Button>
                </Col>
              </Row>
            </Form>
                          <Modal
                            isOpen={Verticalcenter}
                            toggle={Verticalcentermodaltoggle}
                            centered
                          >
                              <ModalHeader 
                              toggle={Verticalcentermodaltoggle}
                              >
                              </ModalHeader>
                              <ModalBody>
                                <div class="icon-container">
                                  <svg class="sparkles" viewBox="0 0 40 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 16L6 4" stroke="#10b981" stroke-width="3" stroke-linecap="round"/>
                                    <path d="M20 14V2" stroke="#10b981" stroke-width="3" stroke-linecap="round"/>
                                    <path d="M30 16L34 4" stroke="#10b981" stroke-width="3" stroke-linecap="round"/>
                                  </svg>
                                  
                                  <div class="green-halo">
                                    <div class="green-circle">
                                      <svg class="checkmark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                      </svg>
                                    </div>
                                  </div>
                                </div>

                                <h2 class="modal-title">Souscription finalisée<br/>avec succès !</h2>
                                <p class="modal-subtitle">Merci pour votre confiance.</p>

                                <div class="voucher-box">
                                  <div class="voucher-icon">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v2z"/>
                                      <path d="M7 5v14" stroke-dasharray="2 4"/>
                                      <path d="M10 12l2 2 4-6"/>
                                    </svg>
                                  </div>
                                  <div class="voucher-divider"></div>
                                  <div class="voucher-text">
                                    Un <strong>voucher de confirmation</strong><br/>vous a été envoyé.
                                  </div>
                                </div>
                              </ModalBody>
                              <ModalFooter>
                                <button class="btn-submit btn-primary" onClick={()=>{Verticalcentermodaltoggle();history.push("/new-sale");}}>Fermer</button>
                              </ModalFooter>
                          </Modal>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default CustomerCareCard;
